var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88091 5.6543C7.537 4.99701 7.537 3.93258 6.88091 3.2753L5.09619 1.49269C4.43927 0.83577 3.37422 0.83577 2.71729 1.49269L1.73912 2.47163C0.890535 3.31891 0.75697 4.647 1.41985 5.6463C4.30049 9.98237 8.01771 13.6997 12.3536 16.5805C13.3531 17.2424 14.6804 17.1096 15.5289 16.2627L16.507 15.2837C16.8227 14.9684 17 14.5404 17 14.0942C17 13.648 16.8227 13.2201 16.507 12.9047L14.723 11.1207C14.4077 10.805 13.9798 10.6277 13.5336 10.6277C13.0874 10.6277 12.6595 10.805 12.3441 11.1207L11.7492 11.7156C9.7557 10.075 7.92604 8.24475 6.286 6.25068L6.88091 5.6543Z",
    stroke: "#086EA1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.455cc0ed3d62a52eff3945bc3c755284.svg";
export { ForwardRef as ReactComponent };